import type { ThemeWithoutTokens } from '../theme.types';

export const dateInputTokens = (theme: ThemeWithoutTokens) =>
  ({
    dateInputOverlayMaxWidth: '20rem',
    dateInputOverlayPaddingX: theme.space.component.x.m,
    dateInputOverlayPaddingY: theme.space.component.y.m,
  }) as const;
